import type { AppRouteRecordRaw } from "@/types/router";
import { LAYOUT } from "@/router/constants";

const item: AppRouteRecordRaw = {
  path: "/",
  name: "Item",
  redirect: "/item",
  component: LAYOUT,
  meta: {
    title: "提报项管理",
  },

  children: [
    {
      path: "item",
      name: "AllianceItem",
      component: () => import("@/views/alliance/item/index.vue"),
      meta: {
        title: "提报项管理",
      },
      children: [
        {
          path: "mapping-batch",
          name: "AllianceMappingBatch",
          component: () => import("@/views/alliance/mapping-batch/index.vue"),
          meta: {
            title: "从映射库添加",
            activeMenu: "/item",
          },
        },
        {
          path: "add",
          name: "AllianceItemAdd",
          component: () => import("@/views/alliance/item-add/index.vue"),
          meta: {
            title: "从企业提报项添加",
            activeMenu: "/item",
          },
        },
      ],
    },
  ],
};

export default item;
